import React from 'react';
import { Popper as PopperComponent, styled } from '@mui/material';
import { getColorFromTheme } from '../../utils';
const MuiPopper = ({ children, placement = 'bottom', open = false, anchorEl, className, _sx, dataTestId, }) => {
    return (React.createElement(PopperComponent, { open: open, anchorEl: anchorEl, placement: placement, className: className, sx: _sx, "data-testid": dataTestId }, children));
};
export const Popper = styled(MuiPopper)(({ theme, arrow, placement, backgroundColor = 'white', color = 'secondary', }) => {
    const background = getColorFromTheme(theme, backgroundColor);
    const fontColor = getColorFromTheme(theme, color);
    const styles = {
        margin: 'auto',
        borderRadius: 2,
        color: fontColor,
        background,
        boxShadow: `2px 4px 14px -8px ${theme.palette.black}`,
    };
    if (arrow) {
        const positionStyles = {};
        if (placement === 'bottom') {
            positionStyles.top = '-6px';
            positionStyles.left = 'calc(50% - 6px)';
        }
        if (placement === 'top') {
            positionStyles.bottom = '-6px';
            positionStyles.left = 'calc(50% - 6px)';
        }
        if (placement === 'left') {
            positionStyles.top = 'calc(50% - 6px)';
            positionStyles.right = '-6px';
        }
        if (placement === 'right') {
            positionStyles.top = 'calc(50% - 6px)';
            positionStyles.left = '-6px';
        }
        styles['&::before'] = Object.assign(Object.assign({}, positionStyles), { backgroundColor: background, content: '""', display: 'block', position: 'absolute', width: 12, height: 12, transform: 'rotate(45deg)' });
    }
    return styles;
});
